import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const TermsAndConditionsq = () => {
    return (
        <div className="container my-5">
            <h1 className="display-5 fw-bold mb-4">
                SECOPP LLC TERMS AND CONDITIONS
            </h1>
            <p className="mb-2">Effective Date: March 1, 2025</p>
            <p className="mb-4">Last Updated: February 27, 2025</p>

            <h2 className="h4 fw-bold mb-3">TABLE OF CONTENTS</h2>
            <ol className="list-group list-group-numbered mb-4">
                <li className="list-group-item">Introduction</li>
                <li className="list-group-item">
                    Eligibility and Registration
                </li>
                <li className="list-group-item">Platform Services</li>
                <li className="list-group-item">
                    Patient Rights and Responsibilities
                </li>
                <li className="list-group-item">
                    Provider Rights and Responsibilities
                </li>
                <li className="list-group-item">Payment Terms</li>
                <li className="list-group-item">Intellectual Property</li>
                <li className="list-group-item">Privacy and Data Security</li>
                <li className="list-group-item">
                    Representations and Warranties
                </li>
                <li className="list-group-item">Limitation of Liability</li>
                <li className="list-group-item">Indemnification</li>
                <li className="list-group-item">Term and Termination</li>
                <li className="list-group-item">Dispute Resolution</li>
                <li className="list-group-item">
                    Additional Terms for Mobile Applications
                </li>
                <li className="list-group-item">International Use</li>
                <li className="list-group-item">General Provisions</li>
                <li className="list-group-item">
                    Jurisdiction-Specific Provisions
                </li>
                <li className="list-group-item">
                    Supplemental Terms for Specific Features
                </li>
            </ol>

            <hr className="my-4" />

            <h2 className="h4 fw-bold mb-3">1. INTRODUCTION</h2>
            <h3 className="h5 fw-bold mb-2">1.1 Agreement to Terms</h3>
            <p className="mb-3">
                Welcome to Secopp LLC (“Secopp,” “Company,” “we,” “our,” or
                “us”). These Terms and Conditions (“Terms”) govern your access
                to and use of the Secopp telemedicine platform, including our
                website located at www.secopp.com, mobile applications, and all
                related services (collectively, the “Platform”).
            </p>
            <p className="mb-3">
                By accessing or using the Platform, you agree to be bound by
                these Terms and our Privacy Policy. If you are using the
                Platform on behalf of an organization, you are agreeing to these
                Terms for that organization and confirming that you have the
                authority to bind that organization to these Terms. In such
                cases, “you” and “your” will refer to that organization.
            </p>
            <p className="mb-3 fw-bold">
                PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
                PLATFORM. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT ACCESS
                OR USE THE PLATFORM.
            </p>

            <h3 className="h5 fw-bold mb-2">
                1.2 Definitions and Interpretation
            </h3>
            <p className="mb-3">
                Throughout these Terms, the following definitions apply:
            </p>
            <ul className="list-group list-group-flush mb-4">
                <li className="list-group-item">
                    <strong>“Content”</strong> means all text, images, photos,
                    audio, video, graphics, and data made available through the
                    Platform.
                </li>
                <li className="list-group-item">
                    <strong>“Healthcare Provider” or “Provider”</strong> means
                    licensed physicians, specialists, and other healthcare
                    professionals who provide medical services through the
                    Platform.
                </li>
                <li className="list-group-item">
                    <strong>“Patient”</strong> means an individual who uses the
                    Platform to receive telemedicine services.
                </li>
                <li className="list-group-item">
                    <strong>“Personal Information”</strong> means information
                    that identifies, relates to, describes, is capable of being
                    associated with, or could reasonably be linked, directly or
                    indirectly, with a particular individual.
                </li>
                <li className="list-group-item">
                    <strong>“Protected Health Information” or “PHI”</strong>{" "}
                    means individually identifiable health information
                    transmitted or maintained in electronic or other form, as
                    defined under the Health Insurance Portability and
                    Accountability Act of 1996 (“HIPAA”).
                </li>
                <li className="list-group-item">
                    <strong>“Services”</strong>means all services provided
                    through the Platform, including telemedicine consultations,
                    prescription services, and health monitoring.
                </li>
                <li className="list-group-item">
                    <strong>“User”</strong> means any individual who accesses or
                    uses the Platform, including Patients and Healthcare
                    Providers.
                </li>
                <h3 className="h5 fw-bold mb-2">1.3 Electronic Contracting</h3>
                <p>
                    You agree that these Terms constitute a legally binding
                    agreement between you and Secopp. You further acknowledge
                    and agree that your electronic consent to these Terms has
                    the same legal effect as a physical signature and
                    constitutes your agreement and intent to be bound by these
                    Terms.
                </p>
                <p>
                    You consent to receive communications from us
                    electronically, and you agree that all agreements, notices,
                    disclosures, and other communications that we provide to you
                    electronically satisfy any legal requirement that such
                    communications be in writing.
                </p>
                <h3 className="h5 fw-bold mb-2">1.4 Platform Description</h3>
                <p>
                    The Platform is a telemedicine service that connects
                    patients in India with licensed healthcare providers in the
                    United States for remote medical consultations, prescription
                    services, and health monitoring. The Platform is designed to
                    facilitate healthcare services across international borders
                    in compliance with applicable laws and regulations in both
                    the United States and India.
                </p>
                <p>
                    The Platform is not intended to replace a primary care
                    physician or in-person medical care, and it is not an
                    emergency service. If you are experiencing a medical
                    emergency, please dial your local emergency number (such as
                    911 in the United States or 112 in India) or go to the
                    nearest emergency room.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    1.5 Relationship to Other Agreements
                </h3>
                <p>
                    These Terms incorporate by reference the following
                    additional agreements, which also govern your use of the
                    Platform:
                </p>
                <li className="list-group-item">
                    <strong>Privacy Policy:</strong> Our Privacy Policy
                    describes how we collect, use, and share your information.
                </li>
                <li className="list-group-item">
                    <strong>Notice of Privacy Practices:</strong> For U.S.
                    users, this document explains your rights regarding your
                    protected health information under HIPAA.
                </li>
                <li className="list-group-item">
                    <strong>Informed Consent for Telemedicine Services:</strong>{" "}
                    Before receiving healthcare services through the Platform,
                    you will be asked to review and agree to this document,
                    which explains the nature and limitations of telemedicine
                    services.
                </li>
                <li className="list-group-item">
                    <strong>Healthcare Provider Agreements:</strong> Healthcare
                    Providers are also subject to additional terms that govern
                    their provision of services through the Platform.
                </li>
                <p>
                    In the event of any conflict between these Terms and any of
                    the above agreements, the terms of these Terms shall control
                    with respect to your use of the Platform.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2. ELIGIBILITY AND REGISTRATION
                </h3>
                <p>
                    To use the Platform, you must meet the following eligibility
                    requirements:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Age:</strong> Be at least 18 years of age, or be
                        at least 13 years of age and have the consent and
                        supervision of a parent or legal guardian.
                    </li>
                    <li className="list-group-item">
                        <strong>Legal Capacity:</strong> Have the legal capacity
                        to enter into these Terms.
                    </li>
                    <li className="list-group-item">
                        <strong>Account Status:</strong> Not have been
                        previously suspended or removed from the Platform.
                    </li>
                    <li className="list-group-item">
                        <strong>Compliance:</strong> Comply with all applicable
                        laws and regulations, including those in your country of
                        residence.
                    </li>
                </ul>
                <p>For Patients:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Residency:</strong> Reside in India or be
                        physically present in India while receiving services.
                    </li>
                    <li className="list-group-item">
                        <strong>Connectivity:</strong> Have the ability to
                        participate in video consultations with adequate
                        internet connection.
                    </li>
                    <li className="list-group-item">
                        <strong>Emergency Status:</strong> Not be experiencing a
                        medical emergency.
                    </li>
                </ul>
                <p>For Healthcare Providers:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>License:</strong> Hold an active, unrestricted
                        license to practice medicine in the United States.
                    </li>
                    <li className="list-group-item">
                        <strong>Insurance:</strong> Maintain appropriate
                        professional liability insurance.
                    </li>
                    <li className="list-group-item">
                        <strong>Qualifications:</strong> Have the qualifications
                        and training necessary to provide the services offered
                        through the Platform.
                    </li>
                    <li className="list-group-item">
                        <strong>Compliance:</strong> Comply with all applicable
                        laws, regulations, and professional standards in the
                        United States and, as applicable, in India.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">
                    2.2 Account Registration Process
                </h3>
                <p>
                    To use the Platform, you must create an account by providing
                    accurate and complete information as prompted by the
                    registration form. You agree to maintain and promptly update
                    your account information to keep it accurate and complete.
                </p>

                <p>For Patients, the registration process requires:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Full legal name</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Date of birth</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Contact information</strong> (email address and
                        phone number)
                    </li>
                    <li className="list-group-item">
                        <strong>Physical address</strong> in India
                    </li>
                    <li className="list-group-item">
                        <strong>Emergency contact information</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Basic health information</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Payment information</strong>
                    </li>
                </ul>

                <p>
                    For Healthcare Providers, the registration process requires:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Full legal name</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Professional credentials and specialties
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>License information and verification</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Contact information</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Professional liability insurance information
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Board certifications</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Educational background and training</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Professional background check consent</strong>
                    </li>
                </ul>

                <p>
                    We reserve the right to reject any registration or to
                    terminate any account at our sole discretion.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.3 Account Security Responsibilities
                </h3>
                <p>
                    You are responsible for maintaining the confidentiality of
                    your account credentials and for all activities that occur
                    under your account. You agree to:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Create a strong, unique password</strong> for
                        your account.
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Keep your account credentials confidential
                        </strong>{" "}
                        and not share them with any third party.
                    </li>
                    <li className="list-group-item">
                        <strong>Immediately notify us</strong> of any
                        unauthorized use of your account or any other breach of
                        security.
                    </li>
                    <li className="list-group-item">
                        <strong>Ensure that you log out</strong> from your
                        account at the end of each session.
                    </li>
                    <li className="list-group-item">
                        <strong>Use secure internet connections</strong> when
                        accessing the Platform.
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Comply with any additional security measures
                        </strong>{" "}
                        we may implement from time to time.
                    </li>
                </ul>

                <p>
                    We will not be liable for any loss or damage arising from
                    your failure to comply with these security obligations.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.4 Provider Verification and Credentialing
                </h3>
                <p>
                    All Healthcare Providers on the Platform undergo a rigorous
                    verification and credentialing process that includes:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Verification of medical education and training
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Confirmation of active, unrestricted medical
                            licensure
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Review of board certifications</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Verification of professional liability insurance
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Background checks</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Reference checks</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Review of disciplinary actions and malpractice
                            history
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Ongoing monitoring of credentials and license status
                        </strong>
                    </li>
                </ul>

                <p>
                    While we make reasonable efforts to verify the credentials
                    of Healthcare Providers, we do not guarantee the accuracy of
                    all information provided by Healthcare Providers or their
                    suitability for your specific healthcare needs.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.5 Patient Identity Verification
                </h3>
                <p>
                    To ensure the security and integrity of healthcare services,
                    we verify the identity of all Patients using the Platform.
                    Patient identity verification may include:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Validation of government-issued identification
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Two-factor authentication</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Video verification during consultations</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Biometric verification (where available and with
                            consent)
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Knowledge-based authentication questions
                        </strong>
                    </li>
                </ul>

                <p>
                    You agree to cooperate with our identity verification
                    procedures and understand that failure to complete
                    verification may result in limited or denied access to the
                    Platform.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    2.6 Account Restrictions and Termination
                </h3>
                <p>
                    We reserve the right to suspend or terminate your account
                    and access to the Platform at any time and for any reason,
                    including but not limited to:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Violation of these Terms</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Providing false or misleading information
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Engaging in fraudulent or illegal activities
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Inappropriate behavior toward Healthcare Providers
                            or our staff
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Using the Platform for unauthorized purposes
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Failure to pay for services</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Inactivity for an extended period</strong>
                    </li>
                </ul>

                <p>
                    If we suspend or terminate your account, you may be
                    prohibited from registering a new account or accessing the
                    Platform in the future. We will comply with applicable laws
                    regarding the maintenance and transfer of medical records in
                    the event of account termination.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    3.1 Service Description and Limitations
                </h3>
                <p>
                    The Platform provides the following telemedicine services:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Virtual consultations with licensed U.S. physicians
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Medical advice and treatment recommendations
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Health monitoring and follow-up care</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Secure messaging between patients and providers
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Electronic health record maintenance</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Educational health resources</strong>
                    </li>
                </ul>

                <p>The Platform is subject to the following limitations:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            The Platform is not a substitute for in-person
                            medical care.
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Not all medical conditions are appropriate for
                            telemedicine consultation.
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Healthcare Providers may determine that your
                            condition requires in-person evaluation.
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Technological limitations may affect the quality of
                            services.
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            The Platform does not guarantee the availability of
                            specific Healthcare Providers.
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Services may be limited by local laws and
                            regulations.
                        </strong>
                    </li>
                    <h3 className="h5 fw-bold mb-2">
                        3.2 Telemedicine Consultation Services
                    </h3>
                    <p>
                        Telemedicine consultations are conducted by licensed
                        Healthcare Providers via secure video connection. These
                        consultations allow for:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>
                                Evaluation of symptoms and medical concerns
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Discussion of medical history</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Visual examination as possible through video
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Diagnosis of certain conditions</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Treatment recommendations</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Prescription of certain medications (where
                                appropriate)
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Referrals to specialists or in-person care when
                                necessary
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Follow-up consultations</strong>
                        </li>
                    </ul>

                    <p>
                        Healthcare Providers have sole discretion to determine
                        whether your condition is appropriate for telemedicine
                        and may decline to provide services if they determine
                        in-person care is necessary. By using the Platform, you
                        acknowledge the inherent limitations of telemedicine and
                        agree that certain conditions may require in-person
                        evaluation and treatment.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        3.3 Prescription Services Exclusion
                    </h3>
                    <p>
                        NO PRESCRIPTION SERVICES. NOTWITHSTANDING ANY OTHER
                        PROVISION IN THESE TERMS, SECOPP LLC EXPRESSLY DOES NOT
                        PROVIDE ANY PRESCRIPTION SERVICES THROUGH THE PLATFORM.
                        NO HEALTHCARE PROVIDER ON THE PLATFORM IS AUTHORIZED TO
                        ISSUE, PROVIDE, OR FACILITATE ANY PRESCRIPTION FOR
                        MEDICATION, CONTROLLED SUBSTANCES, OR OTHER PRESCRIPTION
                        ITEMS TO ANY PATIENT THROUGH THE PLATFORM. ANY
                        HEALTHCARE PROVIDER WHO ATTEMPTS TO PRESCRIBE MEDICATION
                        THROUGH THE PLATFORM IS ACTING OUTSIDE THE SCOPE OF
                        AUTHORIZED SERVICES AND IN VIOLATION OF THESE TERMS.
                        USERS ACKNOWLEDGE AND AGREE THAT (1) NO PRESCRIPTION
                        SERVICES WILL BE PROVIDED THROUGH THE PLATFORM, (2)
                        HEALTHCARE PROVIDERS MAY ONLY OFFER CONSULTATIVE
                        SERVICES AND MEDICAL ADVICE, AND (3) PATIENTS REQUIRING
                        PRESCRIPTION MEDICATIONS MUST SEEK SUCH SERVICES FROM
                        LOCAL HEALTHCARE PROVIDERS OUTSIDE THE PLATFORM. SECOPP
                        LLC DISCLAIMS ALL LIABILITY ARISING FROM OR RELATED TO
                        ANY ATTEMPT TO OBTAIN OR PROVIDE PRESCRIPTION SERVICES
                        THROUGH THE PLATFORM.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        3.4 Health Monitoring Services
                    </h3>
                    <p>
                        The Platform may offer health monitoring services that
                        allow Healthcare Providers to:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>Review health data you provide</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Monitor certain health conditions remotely
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Receive updates about your health status
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Provide ongoing care recommendations
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Adjust treatment plans based on your health data
                            </strong>
                        </li>
                    </ul>

                    <p>To use health monitoring services, you may need to:</p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>Input health data manually</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Connect compatible monitoring devices
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Regularly update your health information
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Participate in follow-up consultations
                            </strong>
                        </li>
                    </ul>

                    <p>
                        You understand that health monitoring through the
                        Platform is not continuous real-time monitoring and
                        should not be relied upon for emergency conditions or
                        critical health parameters that require immediate
                        attention.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        3.5 Service Availability and Interruptions
                    </h3>
                    <p>
                        We strive to make the Platform available 24 hours a day,
                        7 days a week. However, we do not guarantee
                        uninterrupted access to the Platform. The Platform may
                        be unavailable during scheduled maintenance periods,
                        unplanned outages, or due to circumstances beyond our
                        control, including but not limited to:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>Internet service provider failures</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Hardware or software malfunctions</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Natural disasters or acts of God</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Government restrictions</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Cyber-attacks or security breaches</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Telecommunications failures</strong>
                        </li>
                    </ul>

                    <p>
                        Healthcare Provider availability is subject to their
                        individual schedules and may vary. We do not guarantee
                        the availability of specific Healthcare Providers at
                        specific times. Appointment scheduling is subject to
                        Provider availability.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        3.6 Emergency Services Disclaimer
                    </h3>
                    <p>
                        <strong>
                            THE PLATFORM IS NOT FOR MEDICAL EMERGENCIES.
                        </strong>{" "}
                        IF YOU ARE EXPERIENCING A MEDICAL EMERGENCY, CALL YOUR
                        LOCAL EMERGENCY NUMBER (SUCH AS 911 IN THE UNITED STATES
                        OR 112 IN INDIA) OR GO TO THE NEAREST EMERGENCY ROOM
                        IMMEDIATELY.
                    </p>
                    <p>
                        The Platform is not designed to address emergency
                        medical conditions and should not be used in
                        life-threatening situations, including but not limited
                        to:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>Chest pain or pressure</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Difficulty breathing</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Severe bleeding</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Poisoning</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Serious burns</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Severe trauma or injury</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Loss of consciousness</strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Suicidal or homicidal thoughts</strong>
                        </li>
                    </ul>

                    <p>
                        We are not responsible for any harm resulting from your
                        use of the Platform for emergency medical conditions or
                        any delay in seeking emergency medical care.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        3.7 Service Modifications
                    </h3>
                    <p>
                        We reserve the right to modify, suspend, or discontinue
                        any part of the Platform or the entire Platform at any
                        time without notice or liability. This includes:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>
                                Adding or removing features or services
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Changing service hours or availability
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Updating software or user interfaces
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Establishing new limitations or restrictions
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Changing fee structures or payment methods
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Modifying Healthcare Provider networks
                            </strong>
                        </li>
                    </ul>
                    <p>
                        If we discontinue the Platform entirely, we will provide
                        notice as required by applicable law and take
                        appropriate steps to ensure continuity of care and
                        access to medical records.
                    </p>
                    <h3 className="h5 fw-bold mb-2">4.1 Patient Rights</h3>
                    <p>
                        As a Patient using the Platform, you have the right to:
                    </p>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <strong>
                                Receive respectful and non-discriminatory care
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Be informed about the capabilities and
                                limitations of telemedicine
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Receive information about the Healthcare
                                Providers who will be providing services
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Receive clear information about diagnosis,
                                treatment options, and recommendations
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Ask questions and have them answered in terms
                                you can understand
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Make informed decisions about your healthcare
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Refuse any recommended treatment or procedure
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Request a different Healthcare Provider
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Access, review, and request amendments to your
                                medical records
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Privacy and confidentiality in accordance with
                                applicable laws
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Be informed of all applicable fees before
                                receiving services
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                Provide feedback about your experience
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>
                                File complaints about the care received
                            </strong>
                        </li>
                        <li className="list-group-item">
                            <strong>Terminate services at any time</strong>
                        </li>
                    </ul>
                </ul>
                <h3 className="h5 fw-bold mb-2">4.2 Medical Records Access</h3>
                <p>
                    You have the right to access your medical records maintained
                    on the Platform. To request access to your medical records:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Login to your account and navigate to the Medical
                            Records section
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Submit a request through the designated form
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Contact our support team for assistance</strong>
                    </li>
                </ul>
                <p>
                    We will process your request in accordance with applicable
                    laws, including HIPAA for U.S. users. Medical records will
                    be provided in electronic format unless otherwise requested.
                    We may charge a reasonable, cost-based fee for providing
                    copies of records in accordance with applicable laws.
                </p>
                <p>
                    You may also request amendments to your medical records if
                    you believe information is incorrect or incomplete. We will
                    review such requests and make appropriate changes or note
                    your disagreement in the record if the Healthcare Provider
                    determines the information should not be changed.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    4.3 Informed Consent Requirements
                </h3>
                <p>
                    Before receiving healthcare services through the Platform,
                    you will be required to provide informed consent. The
                    informed consent process includes:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Information about the nature of telemedicine
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Discussion of potential benefits, risks, and
                            limitations
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Alternative options to telemedicine</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Privacy considerations specific to telemedicine
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Technical requirements and potential technical
                            failures
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Protocol for emergency situations</strong>
                    </li>
                </ul>
                <p>
                    Your informed consent will be documented in your medical
                    record. You may withdraw consent at any time by contacting
                    us, though this will not affect the lawfulness of the
                    services already provided.
                </p>
                <p>
                    Healthcare Providers may require additional specific consent
                    for certain procedures or treatments beyond the general
                    telemedicine consent.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    4.4 Patient Responsibilities
                </h3>
                <p>
                    As a Patient using the Platform, you have the responsibility
                    to:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Provide complete and accurate information
                        </strong>{" "}
                        about your medical history, current medications,
                        allergies, and symptoms
                    </li>
                    <li className="list-group-item">
                        <strong>Be honest</strong> about your health behaviors
                        and adherence to treatment plans
                    </li>
                    <li className="list-group-item">
                        <strong>Inform the Healthcare Provider</strong> if you
                        do not understand the treatment plan or are unable to
                        follow it
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Respect the time of Healthcare Providers
                        </strong>{" "}
                        by attending scheduled appointments or canceling with
                        reasonable notice
                    </li>
                    <li className="list-group-item">
                        <strong>Conduct yourself in a respectful manner</strong>{" "}
                        during all interactions
                    </li>
                    <li className="list-group-item">
                        <strong>Pay for services as agreed</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Follow up with in-person care</strong> when
                        recommended by Healthcare Providers
                    </li>
                    <li className="list-group-item">
                        <strong>Seek emergency services</strong> when
                        appropriate
                    </li>
                    <li className="list-group-item">
                        <strong>Inform us of changes</strong> in your contact or
                        payment information
                    </li>
                    <li className="list-group-item">
                        <strong>Comply with these Terms</strong> and all
                        applicable laws
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">
                    4.5 Accurate Information Provision
                </h3>
                <p>
                    You agree to provide accurate, current, and complete
                    information about yourself during registration and in all
                    interactions with Healthcare Providers. This includes:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Your true identity and personal information
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Your complete medical history</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>All current medications and supplements</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Known allergies and adverse reactions</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Current symptoms and their duration</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Previous treatments and their outcomes</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Lifestyle factors relevant to your health
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Any other information requested by the Healthcare
                            Provider
                        </strong>
                    </li>
                </ul>
                <p>
                    Providing false, misleading, or incomplete information may
                    result in:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Improper diagnosis or treatment</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Termination of your account</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Denial of future services</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Legal liability</strong>
                    </li>
                </ul>
                <p>
                    You agree to promptly update your information if any changes
                    occur that may affect your care.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    4.6 Prohibited Patient Activities
                </h3>
                <p>The following activities are strictly prohibited:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Seeking treatment for another person while
                            representing that it is for yourself
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Sharing your account credentials with others
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Recording consultations without the express
                            permission of the Healthcare Provider
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Using the Platform for any fraudulent or illegal
                            purpose
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Seeking multiple prescriptions from different
                            Healthcare Providers for the same condition
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Selling or transferring prescriptions or medications
                            obtained through the Platform
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Harassing, threatening, or being abusive toward
                            Healthcare Providers or staff
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Attempting to manipulate Healthcare Providers to
                            prescribe specific medications
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Using the Platform while under the influence of
                            substances that impair your ability to participate
                            effectively
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Violating the intellectual property rights of Secopp
                            or any third party
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Attempting to reverse engineer, decompile, or
                            disassemble the Platform
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Using automated systems, bots, scrapers, or similar
                            technologies to access the Platform
                        </strong>
                    </li>
                </ul>
                <p>
                    Engaging in prohibited activities may result in immediate
                    termination of your account, denial of access to the
                    Platform, legal action, and/or reporting to appropriate
                    authorities.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    5.1 Provider Qualifications and Licensing
                </h3>
                <p>All Healthcare Providers on the Platform must:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Hold a valid, current, and unrestricted license to
                            practice medicine in at least one U.S. state
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Maintain appropriate professional liability
                            insurance
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Have completed the required education and training
                            for their specialty
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Be in good standing with relevant medical boards and
                            authorities
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Complete Secopp’s credentialing process</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Maintain compliance with continuing education
                            requirements
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Adhere to all applicable laws, regulations, and
                            professional standards
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Understanding of cross-border telemedicine
                            regulations
                        </strong>
                    </li>
                </ul>
                <p>
                    Healthcare Providers must immediately notify Secopp of any
                    changes in their licensure status, including investigations,
                    restrictions, suspensions, or revocations.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    5.2 Standard of Care Obligations
                </h3>
                <p>
                    Healthcare Providers must provide services that meet the
                    applicable standard of care for their profession and
                    specialty. This includes:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Conducting appropriate evaluations within the
                            limitations of telemedicine
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Obtaining adequate medical history and information
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Making clinical judgments based on available
                            information
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Providing evidence-based recommendations when
                            possible
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Recognizing the limitations of telemedicine and
                            recommending in-person care when appropriate
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Maintaining adequate documentation of all patient
                            encounters
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Following up on test results and referrals as
                            appropriate
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Adhering to specialty-specific clinical guidelines
                            and protocols
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Remaining current with medical knowledge and best
                            practices
                        </strong>
                    </li>
                </ul>
                <p>
                    Healthcare Providers acknowledge that the standard of care
                    for telemedicine may evolve and agree to adapt their
                    practices accordingly.
                </p>
                <h3 className="h5 fw-bold mb-2">5.3 Provider Discretion</h3>
                <p>
                    Healthcare Providers maintain full professional autonomy and
                    clinical discretion when using the Platform. This includes
                    the right to:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Determine whether a Patient’s condition is
                            appropriate for telemedicine
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Decline to treat a Patient if they determine it is
                            not in the Patient’s best interest
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Recommend in-person evaluation when deemed necessary
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Make independent clinical judgments about diagnosis
                            and treatment
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Prescribe medications based on their professional
                            judgment and applicable laws
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Terminate a consultation if a Patient becomes
                            abusive or inappropriate
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Establish their own availability and schedule
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Determine the appropriate length of consultations
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Refer Patients to other healthcare professionals
                            when appropriate
                        </strong>
                    </li>
                </ul>
                <p>
                    Healthcare Providers are not obligated to prescribe any
                    specific medication or treatment requested by a Patient and
                    will make decisions based on their professional judgment,
                    applicable standards of care, and relevant laws.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    5.4 Documentation Requirements
                </h3>
                <p>
                    Healthcare Providers must maintain thorough and accurate
                    documentation of all Patient encounters, including:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Date and time of the consultation</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Chief complaint or reason for the encounter
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Relevant medical history reviewed</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Review of symptoms</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Assessment and diagnosis (or differential diagnosis)
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Treatment plan and recommendations</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Patient education provided</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Follow-up instructions</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Referrals made</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Informed consent discussions</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Duration of the encounter</strong>
                    </li>
                </ul>
                <p>
                    Documentation must be completed in a timely manner following
                    each encounter and must meet applicable legal, regulatory,
                    and professional standards.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    5.5 Prohibited Provider Activities
                </h3>
                <p>Healthcare Providers are prohibited from:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Practicing outside the scope of their license or
                            training
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Prescribing medications in violation of applicable
                            laws or regulations
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Establishing inappropriate personal or romantic
                            relationships with Patients
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Discriminating against Patients based on race,
                            ethnicity, national origin, religion, gender, gender
                            identity, sexual orientation, disability, or any
                            other protected characteristic
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Providing services while impaired by alcohol, drugs,
                            or other substances
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Sharing Patient information in violation of privacy
                            laws
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Making false or misleading statements about their
                            qualifications or services
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Billing for services not provided or inappropriately
                            coding services
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Soliciting Patients to transfer care outside the
                            Platform
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Using the Platform to promote products or services
                            for personal financial gain
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Making guarantees about treatment outcomes
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Engaging in fee-splitting or kickback arrangements
                        </strong>
                    </li>
                </ul>
                <p>
                    Violations of these prohibitions may result in immediate
                    suspension or termination of the Provider’s access to the
                    Platform, reporting to relevant licensing boards or
                    authorities, and other appropriate actions.
                </p>
                <h3 className="h5 fw-bold mb-2">5.6 Provider Availability</h3>
                <p>Healthcare Providers agree to:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>
                            Maintain their availability schedule on the Platform
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Provide reasonable notice for changes to their
                            availability
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Be punctual for scheduled appointments</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Respond to Patient messages within the timeframe
                            specified in their Provider agreement
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Have adequate technical capabilities to provide
                            quality video consultations
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Arrange for appropriate coverage during periods of
                            unavailability
                        </strong>
                    </li>
                    <li className="list-group-item">
                        <strong>Notify Secopp of extended absences</strong>
                    </li>
                    <li className="list-group-item">
                        <strong>
                            Follow established protocols for handoffs when care
                            must be transferred to another Provider
                        </strong>
                    </li>
                </ul>
                <p>
                    Healthcare Providers understand that reliability and
                    responsiveness are essential for quality care and Patient
                    satisfaction.
                </p>
                <h3 className="h5 fw-bold mb-2">6.1 Fee Structure</h3>
                <p>The Platform uses the following fee structure:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Consultation Fees:</strong> Fixed or variable
                        fees based on consultation type, duration, Provider
                        specialty, and service complexity
                    </li>
                    <li className="list-group-item">
                        <strong>Administrative Fees:</strong> Fees for services
                        such as medical record transfers, expedited
                        appointments, or specialized documentation
                    </li>
                </ul>
                <p>
                    All fees are denominated in U.S. Dollars (USD) or Indian
                    Rupees (INR) as applicable. Current fees for services are
                    posted on the Platform and may be updated from time to time.
                    You are responsible for reviewing the fee information before
                    scheduling services.
                </p>
                <h3 className="h5 fw-bold mb-2">6.1 Fee Structure</h3>
                <p>The Platform uses the following fee structure:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Consultation Fees:</strong> Fixed or variable
                        fees based on consultation type, duration, Provider
                        specialty, and service complexity.
                    </li>
                    <li className="list-group-item">
                        <strong>Administrative Fees:</strong> Fees for services
                        such as medical record transfers, expedited
                        appointments, or specialized documentation.
                    </li>
                </ul>
                <p>
                    All fees are denominated in U.S. Dollars (USD) or Indian
                    Rupees (INR) as applicable. Current fees for services are
                    posted on the Platform and may be updated from time to time.
                    You are responsible for reviewing the fee information before
                    scheduling services.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    6.3 Insurance and Third-Party Payers
                </h3>
                <p>
                    Currently, the Platform does not directly bill insurance
                    companies or third-party payers. However:
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        We will provide you with an itemized receipt that you
                        may submit to your insurance for potential
                        reimbursement.
                    </li>
                    <li className="list-group-item">
                        You are responsible for understanding your insurance
                        coverage for telemedicine services.
                    </li>
                    <li className="list-group-item">
                        You remain responsible for payment regardless of
                        insurance reimbursement.
                    </li>
                    <li className="list-group-item">
                        We may explore relationships with insurance providers in
                        the future.
                    </li>
                    <li className="list-group-item">
                        For patients in India, we may participate in certain
                        private insurance programs or employer healthcare
                        benefits. If applicable, information about such programs
                        will be available on the Platform.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">6.4 Billing Practices</h3>
                <p>Our billing practices include:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Upfront Disclosure:</strong> We will inform you
                        of all applicable fees before you receive services.
                    </li>
                    <li className="list-group-item">
                        <strong>Payment Timing:</strong> Payment is typically
                        collected at the time of booking or at the discretion of
                        the care coordinator.
                    </li>
                    <li className="list-group-item">
                        <strong>Receipts:</strong> Detailed receipts are
                        provided for all transactions.
                    </li>
                    <li className="list-group-item">
                        <strong>Fee Changes:</strong> We will provide at least
                        30 days’ notice before implementing any fee increases.
                    </li>
                    <li className="list-group-item">
                        <strong>Billing Disputes:</strong> We have a process for
                        addressing billing questions and disputes.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">6.5 Refund Policy</h3>
                <p>Our refund policy is as follows:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        <strong>Consultation Cancellation:</strong> Full refund
                        if cancelled more than 24 hours before the scheduled
                        appointment/consultation; no refund for cancellations
                        less than 2 hours before the appointment or for missed
                        appointments nor if consultation is already provided.
                    </li>
                    <li className="list-group-item">
                        <strong>Technical Failures:</strong> Full refund or
                        rescheduled appointment at no additional cost if a
                        consultation cannot be completed due to technical
                        failures on our end.
                    </li>
                    <li className="list-group-item">
                        <strong>Provider Cancellation:</strong> Full refund if a
                        Provider cancels an appointment, or you may reschedule
                        at no additional cost.
                    </li>
                    <li className="list-group-item">
                        <strong>Service Dissatisfaction:</strong> Refund
                        requests for quality issues will be evaluated on a
                        case-by-case basis.
                    </li>
                    <li className="list-group-item">
                        <strong>Refund Requests:</strong> Refund requests must
                        be submitted within 14 days of the service date.
                        Approved refunds will be processed to the original
                        payment method within 5-10 business days.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">
                    6.6 Late Payment and Failed Transactions
                </h3>
                <p>For failed transactions or late payments:</p>
                <ul className="list-group">
                    <li className="list-group-item">
                        We will attempt to process the payment up to three
                        times.
                    </li>
                    <li className="list-group-item">
                        You will be notified of payment failures via email
                        and/or text message.
                    </li>
                    <li className="list-group-item">
                        Access to non-emergency services may be suspended until
                        payment issues are resolved.
                    </li>
                    <li className="list-group-item">
                        Repeatedly failed payments may result in the requirement
                        of alternative payment methods or prepayment for
                        services.
                    </li>
                    <li className="list-group-item">
                        We are committed to working with patients experiencing
                        financial hardship and may offer payment plans in
                        certain circumstances.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">6.7 Taxes</h3>
                <p>
                    All fees are exclusive of applicable taxes unless otherwise
                    stated. You are responsible for paying all applicable taxes
                    related to your use of the Platform, including but not
                    limited to sales tax, value-added tax (VAT), goods and
                    services tax (GST), or similar taxes.
                </p>
                <ul className="list-group">
                    <li className="list-group-item">
                        For Patients in India, we will collect and remit GST as
                        required by Indian tax laws.
                    </li>
                    <li className="list-group-item">
                        For Healthcare Providers in the United States, we will
                        provide appropriate tax documentation as required by
                        U.S. tax laws.
                    </li>
                    <li className="list-group-item">
                        Tax rates are determined based on various factors,
                        including your location and the type of service
                        provided.
                    </li>
                    <li className="list-group-item">
                        We will display applicable taxes during the checkout
                        process before you complete your purchase.
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">
                    7.1 Ownership of Platform and Content
                </h3>
                <p>
                    The Platform, including all software, visual interfaces,
                    graphics, design, compilation, information, data, and
                    Content, is owned by Secopp or its licensors and is
                    protected by United States and international copyright,
                    trademark, patent, and other intellectual property or
                    proprietary rights laws.
                </p>
                <p>
                    The Content on the Platform includes materials developed by
                    Secopp as well as materials licensed from third parties.
                    Unless otherwise indicated, all Content is owned by or
                    licensed to Secopp.
                </p>
                <p>
                    Nothing in these Terms grants you any right, title, or
                    interest in the Platform or its Content except for the
                    limited license expressly set forth in these Terms.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    7.2 Permitted Use of Platform
                </h3>
                <p>
                    Subject to your compliance with these Terms, Secopp grants
                    you a limited, non-exclusive, non-transferable,
                    non-sublicensable, revocable license to access and use the
                    Platform for its intended purpose of receiving or providing
                    healthcare services.
                </p>
                <p>
                    You may use the Platform only for lawful purposes and in
                    accordance with these Terms. This license does not include
                    any right to:
                </p>
                <ul>
                    <li>
                        Modify, adapt, or hack the Platform or modify another
                        website to falsely imply that it is associated with the
                        Platform
                    </li>
                    <li>
                        Reproduce, duplicate, copy, sell, resell, or exploit any
                        portion of the Platform without express written
                        permission from Secopp
                    </li>
                    <li>
                        Use any data mining, robots, or similar data gathering
                        or extraction methods
                    </li>
                    <li>
                        Frame or utilize framing techniques to enclose any
                        trademark, logo, or other proprietary information
                    </li>
                    <li>
                        Use meta tags or any other “hidden text” utilizing
                        Secopp’s name or trademarks
                    </li>
                    <li>
                        Access the Platform by any means other than through the
                        interfaces provided by Secopp
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">7.3 User-Generated Content</h3>
                <p>
                    By submitting, posting, or displaying any content on or
                    through the Platform (“User-Generated Content”), you grant
                    Secopp a worldwide, non-exclusive, royalty-free license to
                    use, copy, reproduce, process, adapt, modify, publish,
                    transmit, display, and distribute such User-Generated
                    Content for the purposes of providing and improving the
                    Platform.
                </p>
                <p>
                    For Healthcare Providers, User-Generated Content includes
                    medical documentation, treatment plans, prescriptions, and
                    communications with Patients. For Patients, User-Generated
                    Content includes health information, questions, feedback,
                    and communications with Healthcare Providers.
                </p>
                <p>
                    You represent and warrant that you have all rights necessary
                    to grant the licenses contained in this section and that
                    your User-Generated Content does not violate any third
                    party’s intellectual property or other rights.
                </p>
                <h3 className="h5 fw-bold mb-2">7.4 License Grants</h3>
                <p>
                    In addition to the license for User-Generated Content, you
                    grant Secopp:
                </p>
                <ul>
                    <li>
                        The right to use your name, username, and profile
                        information in connection with your User-Generated
                        Content
                    </li>
                    <li>
                        The right to use feedback, suggestions, ideas, or other
                        submissions provided by you without any restriction or
                        obligation to compensate you
                    </li>
                    <li>
                        For Healthcare Providers, the right to use your name,
                        credentials, specialties, and professional profile to
                        promote the Platform and its services
                    </li>
                </ul>
                <p>
                    These license grants survive termination of these Terms or
                    your account.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    7.5 Trademark and Brand Usage
                </h3>
                <p>
                    The Secopp name, logo, and other Secopp trademarks, service
                    marks, graphics, and logos used in connection with the
                    Platform are trademarks or registered trademarks of Secopp
                    in the United States and other countries. You are granted no
                    right or license with respect to any of the aforesaid
                    trademarks.
                </p>
                <p>
                    Healthcare Providers may not use Secopp’s trademarks or
                    branding in any manner that suggests endorsement or
                    affiliation beyond the actual relationship established
                    through the Platform, without Secopp’s prior written
                    permission.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    7.6 Copyright Infringement Reporting
                </h3>
                <p>
                    If you believe that any Content on the Platform infringes
                    your copyright, please notify us by providing the following
                    information:
                </p>
                <ul>
                    <li>
                        An electronic or physical signature of the person
                        authorized to act on behalf of the copyright owner
                    </li>
                    <li>
                        A description of the copyrighted work that you claim has
                        been infringed
                    </li>
                    <li>
                        A description of where the material that you claim is
                        infringing is located on the Platform
                    </li>
                    <li>
                        Your contact information, including address, telephone
                        number, and email address
                    </li>
                    <li>
                        A statement by you that you have a good faith belief
                        that the disputed use is not authorized by the copyright
                        owner, its agent, or the law
                    </li>
                    <li>
                        A statement by you, made under penalty of perjury, that
                        the above information in your notice is accurate and
                        that you are the copyright owner or authorized to act on
                        the copyright owner’s behalf
                    </li>
                </ul>
                <p>
                    Notices of copyright infringement claims should be sent to:
                </p>
                <p>
                    Secopp LLC
                    <br />
                    Attn: Legal Department
                    <br />
                    Email: admin@secopp.com
                </p>
                <h3 className="h5 fw-bold mb-2">
                    8.1 Privacy Policy Incorporation
                </h3>
                <p>
                    Our{" "}
                    <a
                        href="https://www.secopp.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                    , available at www.secopp.com/privacy-policy, is
                    incorporated into these Terms by reference. By using the
                    Platform, you acknowledge that you have read and understand
                    our Privacy Policy and consent to the collection, use, and
                    disclosure of your information as described therein.
                </p>
                <p>
                    The Privacy Policy explains how we collect, use, share, and
                    protect your personal information and Protected Health
                    Information. It also describes your choices regarding use,
                    access, and correction of your personal information.
                </p>
                <h3 className="h5 fw-bold mb-2">
                    8.2 Protected Health Information Handling
                </h3>
                <p>
                    For users in the United States, we comply with the Health
                    Insurance Portability and Accountability Act of 1996 (HIPAA)
                    and its implementing regulations. Our{" "}
                    <a
                        href="https://www.secopp.com/hipaa-notice"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Notice of Privacy Practices
                    </a>
                    , available at www.secopp.com/hipaa-notice, provides
                    detailed information about your rights under HIPAA and how
                    we handle your Protected Health Information.
                </p>
                <p>
                    For users in India, we comply with applicable Indian laws
                    and regulations regarding healthcare data privacy. We
                    implement appropriate safeguards to protect health
                    information in accordance with the Information Technology
                    (Reasonable Security Practices and Procedures and Sensitive
                    Personal Data or Information) Rules, 2011, and other
                    applicable Indian laws.
                </p>
                <h3 className="h5 fw-bold mb-2">8.3 Data Security Measures</h3>
                <p>
                    We implement reasonable and appropriate technical,
                    administrative, and physical safeguards to protect your
                    information. Our security measures include:
                </p>
                <ul>
                    <li>Encryption of data in transit and at rest</li>
                    <li>Multi-factor authentication</li>
                    <li>Access controls and authorization protocols</li>
                    <li>Regular security assessments and testing</li>
                    <li>Staff training on security and privacy</li>
                    <li>
                        Physical security for our facilities and infrastructure
                    </li>
                    <li>Business continuity and disaster recovery plans</li>
                    <li>Regular data backups</li>
                    <li>
                        Security monitoring and incident response procedures
                    </li>
                    <li>Compliance with industry security standards</li>
                </ul>
                <p>
                    While we use commercially reasonable efforts to protect your
                    information, no security system is impenetrable, and we
                    cannot guarantee the absolute security of your information.
                    You are responsible for maintaining the secrecy of your
                    unique password and account information.
                </p>
                <h3 className="h5 fw-bold mb-2">9.1 Platform Warranties</h3>
                <p>Secopp represents and warrants that:</p>
                <ul>
                    <li>
                        We will provide the Platform using commercially
                        reasonable care and skill
                    </li>
                    <li>
                        We will use commercially reasonable efforts to maintain
                        the availability of the Platform, subject to maintenance
                        and outages beyond our reasonable control
                    </li>
                    <li>
                        We will implement reasonable security measures to
                        protect your information
                    </li>
                    <li>
                        We will comply with all applicable laws and regulations
                        in our operation of the Platform
                    </li>
                    <li>
                        We will respond to customer support inquiries in a
                        timely manner
                    </li>
                    <li>
                        We will maintain appropriate insurance coverage for our
                        operations
                    </li>
                    <li>
                        Healthcare Providers on the Platform have been
                        credentialed in accordance with our policies
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">9.2 User Warranties</h3>
                <p>You represent and warrant that:</p>
                <ul>
                    <li>
                        You have the legal capacity to enter into these Terms
                    </li>
                    <li>
                        All information you provide to us is accurate, complete,
                        and current
                    </li>
                    <li>
                        You will use the Platform in compliance with these Terms
                        and all applicable laws
                    </li>
                    <li>
                        You will not use the Platform for any fraudulent or
                        unlawful purpose
                    </li>
                    <li>
                        You will not interfere with the proper operation of the
                        Platform
                    </li>
                    <li>You will keep your account credentials confidential</li>
                    <li>
                        If you are a Healthcare Provider, you hold all required
                        licenses and credentials to provide healthcare services
                        and will maintain them throughout your use of the
                        Platform
                    </li>
                    <li>
                        If you are a Healthcare Provider, you will provide
                        services in accordance with applicable standards of care
                        and professional ethics
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">9.3 Healthcare Disclaimer</h3>
                <p>
                    SECOPP IS A TECHNOLOGY PLATFORM THAT CONNECTS PATIENTS WITH
                    INDEPENDENT HEALTHCARE PROVIDERS. SECOPP IS NOT A HEALTHCARE
                    PROVIDER AND DOES NOT PROVIDE MEDICAL ADVICE, DIAGNOSIS, OR
                    TREATMENT.
                </p>
                <p>
                    The Healthcare Providers on the Platform are independent
                    professionals and are solely responsible for the quality and
                    appropriateness of the care they provide. Secopp does not
                    practice medicine or any other licensed profession, and does
                    not interfere with the practice of medicine or any other
                    licensed profession by Healthcare Providers.
                </p>
                <p>
                    Telemedicine involves limitations compared to in-person
                    healthcare. By using the Platform, you acknowledge that:
                </p>
                <ul>
                    <li>
                        Telemedicine may not be as complete as in-person
                        healthcare
                    </li>
                    <li>
                        There are potential risks of misdiagnosis due to the
                        limitations of telemedicine
                    </li>
                    <li>Technical failures may impede or delay care</li>
                    <li>
                        In some cases, information transmitted may be
                        insufficient for proper medical decision-making
                    </li>
                    <li>
                        Delays in medical evaluation and treatment could occur
                        due to deficiencies or failures of the equipment
                    </li>
                </ul>
                <h3 className="h5 fw-bold mb-2">9.4 Third-Party Services</h3>
                <p>
                    The Platform may integrate with or link to third-party
                    services, applications, or websites. We do not control these
                    third-party services and are not responsible for their
                    availability, reliability, or content. Your use of
                    third-party services is subject to the terms and privacy
                    policies of those services, and we make no representations
                    or warranties regarding such third-party services.
                </p>
                <p>Third-party services may include:</p>
                <ul>
                    <li>Payment processors</li>
                    <li>Identity verification services</li>
                    <li>Electronic health record systems</li>
                    <li>Pharmacy services</li>
                    <li>Laboratory testing services</li>
                    <li>Medical device integrations</li>
                    <li>Healthcare provider directories</li>
                </ul>
                <p>
                    We are not liable for any harm or damages related to your
                    use of or reliance on any third-party services.
                </p>
                <h3 className="h5 fw-bold mb-2">9.5 Warranty Disclaimers</h3>
                <p>
                    EXCEPT AS EXPRESSLY PROVIDED IN THESE TERMS, THE PLATFORM
                    AND ALL CONTENT AND SERVICES PROVIDED THROUGH THE PLATFORM
                    ARE PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTY OF
                    ANY KIND, EITHER EXPRESS OR IMPLIED.
                </p>
                <p>
                    SECOPP SPECIFICALLY DISCLAIMS ALL WARRANTIES AND CONDITIONS
                    OF ANY KIND, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS
                    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
                    NON-INFRINGEMENT, FREEDOM FROM DEFECTS, UNINTERRUPTED USE,
                    AND ALL WARRANTIES IMPLIED FROM ANY COURSE OF DEALING OR
                    USAGE OF TRADE.
                </p>
                <p>
                    SECOPP DOES NOT WARRANT THAT: (A) THE PLATFORM WILL MEET
                    YOUR REQUIREMENTS; (B) OPERATION OF THE PLATFORM WILL BE
                    UNINTERRUPTED OR ERROR-FREE; (C) YOUR USE OF THE PLATFORM
                    WILL BE UNINTERRUPTED, ERROR-FREE OR SECURE; (D) INFORMATION
                    AVAILABLE THROUGH THE PLATFORM WILL BE ACCURATE, RELIABLE,
                    COMPLETE, OR TIMELY; OR (E) THE PLATFORM OR ITS SERVERS ARE
                    FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                </p>
                <p>
                    SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED
                    WARRANTIES, SO THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.
                </p>
                <h3 className="h5 fw-bold mb-2">9.6 Force Majeure</h3>
                <p>
                    Neither Secopp nor you shall be liable for any delay or
                    failure in performance under these Terms resulting from acts
                    beyond the control of such party, including without
                    limitation: acts of God, acts of war, terrorism, riots,
                    civil unrest, insurrection, strikes or other labor problems,
                    epidemics, pandemics, power failures, internet or
                    telecommunications disruptions, earthquake, fire, flood, or
                    other natural disasters, governmental actions, or any
                    similar cause.
                </p>
                <h3 className="h5 fw-bold mb-2">10.1 Liability Caps</h3>
                <p>
                    TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO
                    EVENT SHALL SECOPP, ITS AFFILIATES, DIRECTORS, EMPLOYEES, OR
                    AGENTS BE LIABLE FOR ANY INDIRECT, PUNITIVE, INCIDENTAL,
                    SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING
                    WITHOUT LIMITATION DAMAGES FOR LOSS OF PROFITS, GOODWILL,
                    USE, DATA, OR OTHER INTANGIBLE LOSSES, THAT RESULT FROM THE
                    USE OF, OR INABILITY TO USE, THE PLATFORM.
                </p>
                <p>
                    UNDER NO CIRCUMSTANCES WILL SECOPP’S AGGREGATE LIABILITY TO
                    YOU OR ANY THIRD PARTY IN CONNECTION WITH THE PLATFORM OR
                    THESE TERMS EXCEED THE GREATER OF (A) THE AMOUNTS YOU HAVE
                    PAID TO SECOPP FOR YOUR USE OF THE PLATFORM IN THE TWELVE
                    (12) MONTHS PRECEDING THE EVENT GIVING RISE TO THE
                    LIABILITY, OR (B) $100 USD.
                </p>
                <p>
                    The foregoing limitations will apply even if Secopp has been
                    informed of the possibility of such damages and even if a
                    remedy fails of its essential purpose.
                </p>
                <h3 className="h5 fw-bold mb-2">10.2 Types of Damages</h3>
                <p>
                    Without limiting the foregoing, Secopp shall not be liable
                    for:
                </p>
                <ul>
                    <li>
                        Damages resulting from unauthorized access to or
                        alteration of your transmissions or data
                    </li>
                    <li>
                        Statements or conduct of any third party on the
                        Platform, including Healthcare Providers
                    </li>
                    <li>
                        Any action taken in connection with an investigation by
                        Secopp or law enforcement authorities
                    </li>
                    <li>
                        Any injury, death, or bodily harm arising from
                        telemedicine services provided by Healthcare Providers
                    </li>
                    <li>
                        Any economic harm, including lost profits or revenue
                    </li>
                    <li>Any loss of data or content</li>
                    <li>
                        Any interruption or cessation of transmission to or from
                        the Platform
                    </li>
                    <li>
                        Any bugs, viruses, or other harmful code that may be
                        transmitted through the Platform
                    </li>
                    <li>
                        Any errors or omissions in any content or for any loss
                        or damage incurred as a result of the use of any content
                    </li>
                    <li>
                        The quality or outcomes of healthcare services provided
                        by Healthcare Providers
                    </li>
                    <h3 className="h5 fw-bold mb-2">
                        10.3 Basis of the Bargain
                    </h3>
                    <p>
                        The limitations of damages set forth above are
                        fundamental elements of the basis of the bargain between
                        Secopp and you. You specifically acknowledge that Secopp
                        would not be able to provide the Platform on an economic
                        basis without these limitations.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        10.4 Exceptions to Limitations
                    </h3>
                    <p>
                        Some jurisdictions do not allow the exclusion or
                        limitation of liability for consequential or incidental
                        damages, so the above limitations may not apply to you.
                        In such cases, Secopp’s liability will be limited to the
                        fullest extent permitted by applicable law.
                    </p>
                    <p>
                        Nothing in these Terms shall limit or exclude our
                        liability for:
                    </p>
                    <ul>
                        <li>
                            Death or personal injury resulting from our
                            negligence
                        </li>
                        <li>Fraud or fraudulent misrepresentation</li>
                        <li>
                            Any other liability that cannot be excluded or
                            limited by law
                        </li>
                    </ul>

                    <h3 className="h5 fw-bold mb-2">
                        10.5 Jurisdictional Limitations
                    </h3>
                    <p>
                        If you are a resident of a jurisdiction that requires a
                        specific statement regarding release, then the following
                        applies. For example, California residents must, as a
                        condition of this Agreement, waive the applicability of
                        California Civil Code Section 1542, which states, “A
                        GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE
                        CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER
                        FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF
                        KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR
                        HER SETTLEMENT WITH THE DEBTOR.” You hereby waive this
                        section of the California Civil Code. You hereby waive
                        any similar provision in law, regulation, or code that
                        has the same intent or effect as the aforementioned
                        release.
                    </p>
                    <h3 className="h5 fw-bold mb-2">11. INDEMNIFICATION</h3>

                    <h4 className="h6 fw-bold mb-2">
                        11.1 User Indemnification Obligations
                    </h4>
                    <p>
                        You agree to defend, indemnify, and hold harmless
                        Secopp, its affiliates, directors, officers, employees,
                        and agents from and against any and all claims, damages,
                        obligations, losses, liabilities, costs or debt, and
                        expenses (including but not limited to attorney’s fees)
                        arising from:
                    </p>
                    <ul>
                        <li>Your use of and access to the Platform</li>
                        <li>Your violation of any provision of these Terms</li>
                        <li>
                            Your violation of any third-party right, including
                            without limitation any intellectual property right,
                            privacy right, or publicity right
                        </li>
                        <li>
                            Any content you upload, post, email, transmit, or
                            otherwise make available through the Platform
                        </li>
                        <li>
                            Your violation of any applicable laws, rules, or
                            regulations
                        </li>
                        <li>
                            Any claim that your actions caused harm to a third
                            party
                        </li>
                        <li>
                            Any medical malpractice or professional negligence
                            claims arising from your use of the Platform
                        </li>
                        <li>
                            If you are a Healthcare Provider, any services you
                            provide through the Platform
                        </li>
                    </ul>
                    <p>
                        This defense and indemnification obligation will survive
                        these Terms and your use of the Platform.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        11.2 Company Defense Rights
                    </h4>
                    <p>
                        We reserve the right, at our own expense, to assume the
                        exclusive defense and control of any matter otherwise
                        subject to indemnification by you, in which event you
                        will cooperate with us in asserting any available
                        defenses.
                    </p>
                    <p>
                        You agree that you will not settle any claim that
                        affects Secopp or our affiliates without our prior
                        written approval.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        11.3 Indemnification Procedures
                    </h4>
                    <p>
                        If you are obligated to indemnify us, we will have the
                        right, in our sole discretion, to control any action or
                        proceeding and determine whether we wish to settle it,
                        and if so, on what terms.
                    </p>
                    <p>In the event of such a claim, we will:</p>
                    <ul>
                        <li>Provide you with written notice of the claim</li>
                        <li>
                            Allow you to participate in the defense of the claim
                            (at your expense)
                        </li>
                        <li>
                            Reasonably cooperate with you in defending the claim
                        </li>
                        <li>
                            Not settle or compromise the claim without your
                            written consent, which shall not be unreasonably
                            withheld
                        </li>
                    </ul>
                    <p>You must:</p>
                    <ul>
                        <li>Promptly notify us in writing of any such claim</li>
                        <li>
                            Allow us to control the defense and settlement of
                            the claim
                        </li>
                        <li>
                            Reasonably cooperate with us in the defense and
                            settlement of the claim
                        </li>
                    </ul>

                    <h4 className="h6 fw-bold mb-2">11.4 Exclusive Remedy</h4>
                    <p>
                        The indemnity and defense provisions in this section
                        constitute the sole and exclusive monetary remedy of
                        Secopp and its directors, officers, employees,
                        affiliates, and agents for any claim subject to
                        indemnification under these Terms.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        12. TERM AND TERMINATION
                    </h3>

                    <h4 className="h6 fw-bold mb-2">12.1 Term of Agreement</h4>
                    <p>
                        These Terms commence on the date you first access or use
                        the Platform and continue until terminated as described
                        in these Terms.
                    </p>
                    <p>
                        For subscription plans, the term begins on the
                        subscription start date and continues for the period
                        specified in your subscription plan (e.g., monthly,
                        quarterly, or annual), automatically renewing for
                        successive periods of the same duration unless
                        terminated as provided in these Terms.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        12.2 Termination by User
                    </h4>
                    <p>You may terminate these Terms at any time by:</p>
                    <ul>
                        <li>
                            Closing your account through the Platform settings
                        </li>
                        <li>
                            Sending a written termination notice to{" "}
                            <a href="mailto:support@secopp.com">
                                support@secopp.com
                            </a>
                        </li>
                        <li>
                            For subscription plans, cancelling your subscription
                            through the Platform settings or by contacting
                            customer support
                        </li>
                    </ul>
                    <p>
                        If you are a Patient, termination will not affect any
                        pending appointments or ongoing treatment unless you
                        specifically request cancellation of these services. You
                        will remain responsible for any fees incurred prior to
                        termination.
                    </p>
                    <p>
                        If you are a Healthcare Provider, you must provide at
                        least thirty (30) days’ advance written notice of
                        termination and must continue to provide services for
                        any already-scheduled appointments during that notice
                        period unless alternative arrangements are made for
                        those Patients.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        12.3 Termination by Company
                    </h4>
                    <p>
                        Secopp may terminate or suspend your account and access
                        to the Platform immediately, without prior notice or
                        liability, for any reason, including, without
                        limitation:
                    </p>
                    <ul>
                        <li>Violation of these Terms</li>
                        <li>
                            Provision of inaccurate, outdated, or incomplete
                            information
                        </li>
                        <li>Engagement in fraudulent or illegal activities</li>
                        <li>Failure to pay fees when due</li>
                        <li>
                            Upon receipt of requests or orders from law
                            enforcement or other government agencies
                        </li>
                        <li>
                            If your actions expose Secopp to legal liability or
                            compromise the Platform’s integrity
                        </li>
                        <li>Extended periods of inactivity</li>
                        <li>
                            For Healthcare Providers, loss of license or
                            credentials, or evidence of substandard care
                        </li>
                    </ul>
                    <p>
                        We also reserve the right to terminate or suspend any
                        Healthcare Provider’s access to the Platform if, in our
                        sole discretion, we determine that the Provider’s
                        continued participation would present a risk to Patient
                        safety or Platform integrity.
                    </p>
                    <h3 className="h5 fw-bold mb-2">
                        12.4 Effect of Termination
                    </h3>
                    <p>Upon termination of these Terms:</p>
                    <ul>
                        <li>
                            Your right to access and use the Platform will
                            immediately cease
                        </li>
                        <li>Your account will be deactivated or deleted</li>
                        <li>
                            You will no longer have access to your account
                            information or content
                        </li>
                        <li>
                            Any pending appointments may be cancelled (with
                            notification to affected parties)
                        </li>
                        <li>
                            You remain liable for any outstanding fees or
                            obligations incurred before termination
                        </li>
                        <li>
                            For Healthcare Providers, arrangements will be made
                            for the transition of Patient care
                        </li>
                        <li>
                            If you have an active subscription plan at the time
                            of termination, you may be entitled to a prorated
                            refund for the unused portion of your subscription,
                            depending on the circumstances of termination and
                            subject to our refund policy.
                        </li>
                    </ul>

                    <h3 className="h5 fw-bold mb-2">
                        12.5 Survival Provisions
                    </h3>
                    <p>
                        The following provisions will survive the termination of
                        these Terms:
                    </p>
                    <ul>
                        <li>Intellectual Property (Section 7)</li>
                        <li>Privacy and Data Security (Section 8)</li>
                        <li>Representations and Warranties (Section 9)</li>
                        <li>Limitation of Liability (Section 10)</li>
                        <li>Indemnification (Section 11)</li>
                        <li>Dispute Resolution (Section 13)</li>
                        <li>
                            Any payment obligations incurred prior to
                            termination
                        </li>
                        <li>
                            Any other provisions that by their nature should
                            survive termination
                        </li>
                    </ul>

                    <h3 className="h5 fw-bold mb-2">
                        12.6 Post-Termination Medical Record Access
                    </h3>
                    <p>
                        Following termination, we will maintain your medical
                        records in accordance with applicable laws and our
                        record retention policies. You may request access to
                        your medical records after termination by:
                    </p>
                    <ul>
                        <li>
                            Submitting a written request to{" "}
                            <a href="mailto:records@secopp.com">
                                records@secopp.com
                            </a>
                        </li>
                        <li>
                            Completing the medical records request form
                            available on our website
                        </li>
                        <li>Contacting our customer support</li>
                    </ul>
                    <p>
                        For U.S. users, we will maintain and provide access to
                        medical records in accordance with HIPAA and other
                        applicable laws. For users in India, we will maintain
                        and provide access to medical records in accordance with
                        applicable Indian laws and regulations.
                    </p>
                    <p>
                        Healthcare Providers are responsible for making
                        appropriate arrangements for the transition of Patient
                        care upon termination of their use of the Platform,
                        including provision of summary records and referrals as
                        appropriate.
                    </p>
                    <h3 className="h5 fw-bold mb-2">13. DISPUTE RESOLUTION</h3>

                    <h4 className="h6 fw-bold mb-2">13.1 Governing Law</h4>
                    <p>
                        These Terms shall be governed by and construed in
                        accordance with the laws of the State of Delaware,
                        United States, without regard to its conflict of law
                        principles.
                    </p>
                    <p>
                        For users who are residents of India, to the extent
                        required by applicable Indian law, these Terms shall
                        also be governed by and construed in accordance with the
                        laws of India. However, any disputes shall be resolved
                        through the dispute resolution process described in this
                        section.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        13.2 Informal Dispute Resolution
                    </h4>
                    <p>
                        Before filing a claim against Secopp, you agree to
                        attempt to resolve the dispute informally by contacting
                        us at{" "}
                        <a href="mailto:disputes@secopp.com">
                            disputes@secopp.com
                        </a>
                        . We will attempt to resolve the dispute by contacting
                        you via email. If the dispute is not resolved within 60
                        days of submission, you or Secopp may proceed with
                        filing a formal claim or lawsuit.
                    </p>

                    <h4 className="h6 fw-bold mb-2">
                        13.3 Arbitration Agreement
                    </h4>
                    <p>
                        Except for the right of either party to seek injunctive
                        or other equitable relief or for claims that can be
                        brought in small claims court, any dispute, controversy,
                        or claim arising out of or relating to these Terms, the
                        Platform, or the services provided through the Platform,
                        will be settled by binding arbitration in accordance
                        with the following terms:
                    </p>
                    <ul>
                        <li>
                            <strong>Forum:</strong> The arbitration will be
                            administered by the American Arbitration Association
                            (“AAA”) in accordance with its Commercial
                            Arbitration Rules.
                        </li>
                        <li>
                            <strong>Location:</strong> Unless you and Secopp
                            agree otherwise, the arbitration will be conducted
                            in Delaware, United States. For users in India, upon
                            request, the arbitration may be conducted via video
                            conference to facilitate participation.
                        </li>
                        <li>
                            <strong>Process:</strong> The arbitration will be
                            conducted by a single arbitrator with substantial
                            experience in resolving intellectual property and
                            commercial contract disputes.
                        </li>
                        <li>
                            <strong>Language:</strong> The arbitration
                            proceedings shall be conducted in English.
                        </li>
                        <li>
                            <strong>Confidentiality:</strong> The existence and
                            content of the arbitration proceedings, including
                            all submissions, will be kept confidential, except
                            as necessary to enforce any award.
                        </li>
                        <li>
                            <strong>Costs:</strong> Secopp will pay all
                            arbitration filing fees and arbitrator’s costs and
                            expenses for claims less than $10,000 unless the
                            arbitrator determines the claim is frivolous. For
                            claims over $10,000, the payment of filing fees and
                            arbitrator’s costs will be governed by the AAA
                            Commercial Arbitration Rules.
                        </li>
                        <li>
                            <strong>Award:</strong> The arbitrator shall issue a
                            reasoned written decision sufficient to explain the
                            essential findings and conclusions on which the
                            award is based. The award rendered by the arbitrator
                            shall be final and binding upon the parties, and
                            judgment upon the award may be entered in any court
                            having jurisdiction thereof.
                        </li>
                    </ul>
                </ul>
                <h4 className="h6 fw-bold mb-2">13.4 Class Action Waiver</h4>
                <p>
                    YOU AND SECOPP AGREE THAT EACH MAY BRING CLAIMS AGAINST THE
                    OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A
                    PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS,
                    CONSOLIDATED, OR REPRESENTATIVE ACTION OR PROCEEDING. UNLESS
                    BOTH YOU AND SECOPP AGREE OTHERWISE, THE ARBITRATOR MAY NOT
                    CONSOLIDATE OR JOIN MORE THAN ONE PERSON’S OR PARTY’S CLAIMS
                    AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A
                    CONSOLIDATED, REPRESENTATIVE, OR CLASS PROCEEDING. THE
                    ARBITRATOR MAY AWARD RELIEF ONLY IN FAVOR OF THE INDIVIDUAL
                    PARTY SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO
                    PROVIDE RELIEF NECESSITATED BY THAT PARTY’S INDIVIDUAL
                    CLAIM(S).
                </p>

                <h4 className="h6 fw-bold mb-2">
                    13.5 Small Claims Court Option
                </h4>
                <p>
                    Notwithstanding the foregoing, you may bring an individual
                    action in the small claims court of your state or
                    municipality if the action is within that court’s
                    jurisdiction and is pending only in that court.
                </p>

                <h4 className="h6 fw-bold mb-2">13.6 Opt-Out Procedure</h4>
                <p>
                    You have the right to opt out of the arbitration and class
                    action waiver provisions set forth in Sections 13.3 and 13.4
                    by sending written notice of your decision to opt-out to{" "}
                    <a href="mailto:no-reply@secopp.com">no-reply@secopp.com</a>{" "}
                    within 30 days of your first use of the Platform. If you opt
                    out, neither you nor Secopp can require the other to
                    participate in an arbitration proceeding.
                </p>
                <p>
                    If you do not opt out within this period, you will be bound
                    by the arbitration and class action waiver provisions, as
                    well as all other provisions of these Terms.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    13.7 Venue for Legal Disputes
                </h4>
                <p>
                    If for any reason a claim proceeds in court rather than in
                    arbitration, you and Secopp agree that:
                </p>
                <ul>
                    <li>
                        <strong>
                            If you are a resident of the United States,
                        </strong>{" "}
                        any such claim shall be brought exclusively in the state
                        or federal courts located in Delaware, United States.
                    </li>
                    <li>
                        <strong>If you are a resident of India,</strong> any
                        such claim shall be brought exclusively in courts
                        located in Delaware, United States, or, if required by
                        mandatory provisions of Indian law, in courts located in
                        India with appropriate jurisdiction.
                    </li>
                </ul>
                <p>
                    You and Secopp agree to submit to the personal jurisdiction
                    of the courts located within these venues for the purpose of
                    litigating any such claims.
                </p>
                <h4 className="h6 fw-bold mb-2">14.1 App Store Terms</h4>
                <p>
                    If you download and use our mobile application, the
                    following additional terms apply:
                </p>
                <ul>
                    <li>
                        The terms of agreement with your respective mobile
                        network provider (“Mobile Provider”) will continue to
                        apply when using the mobile application.
                    </li>
                    <li>
                        You agree that Secopp is not responsible for any charges
                        you may incur from your Mobile Provider while using the
                        application.
                    </li>
                </ul>

                <p>
                    <strong>
                        For applications downloaded from Apple’s App Store:
                    </strong>
                </p>
                <ul>
                    <li>
                        You acknowledge that these Terms are between you and
                        Secopp, not with Apple Inc. (“Apple”).
                    </li>
                    <li>
                        Your use of the application must comply with the App
                        Store Terms of Service.
                    </li>
                    <li>
                        Apple has no obligation to furnish any maintenance and
                        support services with respect to the application.
                    </li>
                    <li>
                        In the event of any failure of the application to
                        conform to any applicable warranty, you may notify
                        Apple, and Apple will refund the purchase price for the
                        application to you.
                    </li>
                    <li>
                        Apple is not responsible for addressing any claims by
                        you or any third party relating to the application or
                        your possession and/or use of the application.
                    </li>
                    <li>
                        Apple is not responsible for the investigation, defense,
                        settlement, and discharge of any third-party
                        intellectual property infringement claim.
                    </li>
                    <li>
                        You represent and warrant that you are not located in a
                        country that is subject to a U.S. Government embargo or
                        designated as a “terrorist supporting” country, and you
                        are not listed on any U.S. Government list of prohibited
                        or restricted parties.
                    </li>
                    <li>
                        Apple and its subsidiaries are third-party beneficiaries
                        of these Terms and will have the right to enforce these
                        Terms against you.
                    </li>
                </ul>

                <p>
                    <strong>
                        For applications downloaded from Google Play:
                    </strong>
                </p>
                <ul>
                    <li>
                        You acknowledge that these Terms are between you and
                        Secopp, not with Google LLC (“Google”).
                    </li>
                    <li>
                        Your use of the application must comply with the Google
                        Play Terms of Service.
                    </li>
                    <li>
                        Google is only a provider of the Google Play store where
                        you obtained the application.
                    </li>
                    <li>
                        Secopp, not Google, is solely responsible for the
                        application and its content.
                    </li>
                </ul>
                <h4 className="h6 fw-bold mb-2">
                    14.2 Mobile Device Requirements
                </h4>
                <p>
                    To use our mobile application, you need a compatible mobile
                    device. The application may be updated from time to time,
                    and may not work with older versions of the operating
                    system, software, or hardware.
                </p>
                <p>
                    We do not guarantee that the application will be compatible
                    with all devices. You are responsible for ensuring that your
                    device meets the minimum requirements for the application.
                </p>
                <p>
                    <strong>Current minimum requirements include:</strong>
                </p>
                <ul>
                    <li>For iOS devices: iOS 13.0 or later</li>
                    <li>For Android devices: Android 8.0 or later</li>
                    <li>
                        Adequate storage space for the application and
                        associated data
                    </li>
                    <li>
                        Camera and microphone capabilities for telemedicine
                        consultations
                    </li>
                    <li>Stable internet connection (Wi-Fi or mobile data)</li>
                </ul>

                <h4 className="h6 fw-bold mb-2">14.3 Mobile Data Charges</h4>
                <p>
                    You are responsible for any mobile charges that you may
                    incur for using our application, including data charges, SMS
                    charges, and roaming charges. If you’re not sure what these
                    charges might be, you should ask your Mobile Provider before
                    using the application.
                </p>
                <p>
                    Telemedicine video consultations may consume significant
                    amounts of data. We recommend using Wi-Fi connections when
                    possible to minimize data usage.
                </p>

                <h4 className="h6 fw-bold mb-2">14.4 Push Notifications</h4>
                <p>
                    Our application may send push notifications to your mobile
                    device. You can control or disable these notifications in
                    your device settings.
                </p>
                <p>
                    <strong>Push notifications may include:</strong>
                </p>
                <ul>
                    <li>Appointment reminders</li>
                    <li>Consultation notifications</li>
                    <li>Prescription updates</li>
                    <li>Messages from Healthcare Providers</li>
                    <li>Account updates</li>
                    <li>Emergency alerts</li>
                </ul>

                <h4 className="h6 fw-bold mb-2">14.5 Application Updates</h4>
                <p>
                    We may update the application from time to time for various
                    reasons, including to address security issues, provide new
                    features, or improve performance. Some updates may be
                    mandatory for continued use of the application.
                </p>
                <p>
                    Updates may be issued through the App Store or Google Play,
                    and you agree that the application may automatically
                    download and install updates from time to time. You may also
                    be required to install updates manually to continue using
                    the application.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    14.6 Geographic Restrictions
                </h4>
                <p>
                    The application may not be available in all countries or
                    regions. We may use technologies to prohibit access from
                    jurisdictions where we do not offer our services.
                </p>
                <p>
                    You agree not to circumvent or attempt to circumvent any
                    geographical restrictions we impose.
                </p>
                <h4 className="h6 fw-bold mb-2">15. INTERNATIONAL USE</h4>

                <h4 className="h6 fw-bold mb-2">
                    15.1 Cross-Border Healthcare Regulations
                </h4>
                <p>
                    The Platform facilitates telemedicine services across
                    international borders, specifically between Healthcare
                    Providers in the United States and Patients in India. All
                    users must comply with applicable laws and regulations
                    governing cross-border healthcare in both countries.
                </p>
                <p>
                    <strong>For Healthcare Providers:</strong>
                </p>
                <ul>
                    <li>
                        You are responsible for understanding and complying with
                        legal and regulatory requirements related to providing
                        healthcare services to patients in India.
                    </li>
                    <li>
                        You must be licensed and in good standing in the United
                        States.
                    </li>
                    <li>
                        You must adhere to telehealth practice standards
                        established by relevant U.S. medical boards.
                    </li>
                    <li>
                        You must understand the limitations on prescribing
                        medications across international borders.
                    </li>
                    <li>
                        You must comply with any applicable export controls on
                        healthcare services.
                    </li>
                </ul>

                <p>
                    <strong>For Patients:</strong>
                </p>
                <ul>
                    <li>
                        You acknowledge that Healthcare Providers on the
                        Platform are licensed in the United States, not India.
                    </li>
                    <li>
                        You understand that prescriptions issued through the
                        Platform are subject to restrictions and may not be
                        valid at all pharmacies in India.
                    </li>
                    <li>
                        You agree to comply with all Indian laws and regulations
                        regarding the receipt of healthcare services from
                        foreign providers.
                    </li>
                    <li>
                        You understand that local healthcare regulations may
                        limit certain aspects of care that can be provided
                        through cross-border telemedicine.
                    </li>
                </ul>

                <h4 className="h6 fw-bold mb-2">
                    15.2 Language of the Agreement
                </h4>
                <p>
                    These Terms are written in English. Translations into other
                    languages may be provided for convenience only. In the event
                    of any conflict between the English version and any
                    translation, the English version shall prevail.
                </p>
                <p>
                    For users in India, we may provide summaries or key
                    provisions in other Indian languages upon request, but the
                    English version remains the official and binding version of
                    these Terms.
                </p>

                <h4 className="h6 fw-bold mb-2">15.3 Export Controls</h4>
                <p>
                    The Platform and its underlying technology may be subject to
                    U.S. export control laws and regulations. You agree not to
                    export, re-export, or transfer, directly or indirectly, any
                    technical data or software acquired from Secopp, or any
                    products utilizing such data or software, in violation of
                    U.S. export laws or regulations.
                </p>

                <h4 className="h6 fw-bold mb-2">15.4 Country-Specific Terms</h4>

                <h5 className="h6 fw-bold mb-2">15.4.1 United States</h5>
                <p>
                    If you are accessing or using the Platform from the United
                    States:
                </p>
                <ul>
                    <li>
                        You agree to comply with all applicable federal and
                        state laws, including state telehealth regulations.
                    </li>
                    <li>
                        You understand that healthcare regulations may vary by
                        state, and Healthcare Providers must comply with
                        regulations in their state of licensure.
                    </li>
                    <li>
                        You acknowledge that some states may have restrictions
                        on telemedicine practice that could limit services
                        available through the Platform.
                    </li>
                </ul>

                <h5 className="h6 fw-bold mb-2">15.4.2 India</h5>
                <p>If you are accessing or using the Platform from India:</p>
                <ul>
                    <li>
                        You agree to comply with all applicable Indian laws and
                        regulations, including telemedicine guidelines issued by
                        the Medical Council of India or other relevant
                        authorities.
                    </li>
                    <li>
                        You understand that certain healthcare services and
                        prescriptions may be restricted under Indian law.
                    </li>
                    <li>
                        You acknowledge that in case of conflict between U.S.
                        and Indian healthcare regulations, Healthcare Providers
                        must comply with both sets of regulations, which may
                        result in limitations on available services.
                    </li>
                </ul>

                <h4 className="h6 fw-bold mb-2">
                    15.5 Jurisdictional Limitations
                </h4>
                <p>
                    Secopp makes no representation that the Platform or any
                    content available through the Platform is appropriate or
                    available for use in locations outside the United States and
                    India. If you access the Platform from other locations, you
                    do so at your own risk and are responsible for compliance
                    with local laws.
                </p>
                <p>
                    We reserve the right to limit the availability of the
                    Platform or any service or product described on the Platform
                    to any person or geographic area at any time.
                </p>
                <h4 className="h6 fw-bold mb-2">16. GENERAL PROVISIONS</h4>

                <h4 className="h6 fw-bold mb-2">16.1 Entire Agreement</h4>
                <p>
                    These Terms (including the Privacy Policy and any other
                    agreements expressly incorporated by reference) constitute
                    the entire agreement between you and Secopp concerning your
                    use of the Platform and supersede all prior or
                    contemporaneous communications, proposals, and
                    understandings, whether electronic, oral, or written,
                    between you and Secopp with respect to the Platform.
                </p>

                <h4 className="h6 fw-bold mb-2">16.2 Severability</h4>
                <p>
                    If any provision of these Terms is found to be unenforceable
                    or invalid, that provision will be limited or eliminated to
                    the minimum extent necessary so that these Terms will
                    otherwise remain in full force and effect and enforceable.
                    The invalidity of any term of these Terms shall not affect
                    the validity or enforceability of any of the remaining
                    provisions, which shall remain in full force and effect.
                </p>

                <h4 className="h6 fw-bold mb-2">16.3 No Waiver</h4>
                <p>
                    No waiver of any term of these Terms shall be deemed a
                    further or continuing waiver of such term or any other term,
                    and Secopp’s failure to assert any right or provision under
                    these Terms shall not constitute a waiver of such right or
                    provision.
                </p>
                <p>
                    Any failure by Secopp to enforce any provision of these
                    Terms shall not constitute a waiver of that provision or any
                    other provision. No waiver of any provision shall be
                    effective unless explicitly stated in writing and signed by
                    an authorized representative of Secopp.
                </p>

                <h4 className="h6 fw-bold mb-2">16.4 Assignment</h4>
                <p>
                    You may not assign or transfer these Terms, by operation of
                    law or otherwise, without Secopp’s prior written consent.
                    Any attempt by you to assign or transfer these Terms without
                    such consent will be null and void.
                </p>
                <p>
                    Secopp may assign or transfer these Terms, at its sole
                    discretion, without restriction. Subject to the foregoing,
                    these Terms will bind and inure to the benefit of the
                    parties, their successors and permitted assigns.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    16.5 Relationship of Parties
                </h4>
                <p>
                    No agency, partnership, joint venture, or employment is
                    created as a result of these Terms, and you do not have any
                    authority of any kind to bind Secopp in any respect
                    whatsoever.
                </p>
                <p>
                    For Healthcare Providers, these Terms do not create an
                    employer-employee relationship, and Healthcare Providers are
                    independent contractors, not employees or agents of Secopp.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    16.6 Third-Party Beneficiaries
                </h4>
                <p>
                    These Terms do not confer any third-party beneficiary rights
                    on any person or entity who is not a party to these Terms,
                    except as expressly stated in these Terms.
                </p>

                <h4 className="h6 fw-bold mb-2">16.7 Notices</h4>
                <p>
                    Any notices or other communications permitted or required
                    hereunder will be in writing and given by Secopp:
                </p>
                <ul>
                    <li>
                        via email to the address that you provide during
                        registration
                    </li>
                    <li>via push notification to your mobile device</li>
                    <li>via posting to the Platform</li>
                    <li>
                        via postal mail to the physical address associated with
                        your account
                    </li>
                </ul>
                <p>For notices made by you to Secopp, please use:</p>
                <p>
                    <strong>Email:</strong> admin@secopp.com
                </p>
                <p>
                    Notices provided electronically will be deemed given on the
                    day sent (unless returned as undeliverable), and notices
                    sent by postal mail will be deemed given three business days
                    after mailing.
                </p>

                <h4 className="h6 fw-bold mb-2">16.8 Contact Information</h4>
                <p>
                    For questions or concerns regarding these Terms, please
                    contact us at:
                </p>
                <ul>
                    <li>
                        <strong>Email:</strong> support@secopp.com
                    </li>
                    <li>
                        <strong>Phone:</strong>{" "}
                    </li>
                    <li>
                        <strong>Website Contact Form:</strong>{" "}
                        <a
                            href="www.secopp.com/contact-us"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.secopp.com/contact-us
                        </a>
                    </li>
                </ul>

                <h4 className="h6 fw-bold mb-2">16.9 Changes to Terms</h4>
                <p>
                    We reserve the right, at our sole discretion, to modify or
                    replace these Terms at any time. If a revision is material,
                    we will provide at least 30 days’ notice prior to any new
                    terms taking effect. What constitutes a material change will
                    be determined at our sole discretion.
                </p>
                <p>
                    By continuing to access or use our Platform after those
                    revisions become effective, you agree to be bound by the
                    revised Terms. If you do not agree to the new Terms, you
                    must stop using the Platform and close your account.
                </p>

                <h4 className="h6 fw-bold mb-2">16.10 Electronic Signature</h4>
                <p>
                    Your use of the Platform, creation of an account, or
                    clicking to accept or agree to these Terms (where such
                    option is made available) constitutes your electronic
                    signature to these Terms, which has the same legal effect as
                    a handwritten signature.
                </p>
                <h4 className="h6 fw-bold mb-2">
                    17. JURISDICTION-SPECIFIC PROVISIONS
                </h4>

                <h4 className="h6 fw-bold mb-2">17.1 United States</h4>

                <h4 className="h6 fw-bold mb-2">
                    17.1.1 State Telehealth Laws
                </h4>
                <p>
                    Healthcare Providers must comply with telehealth laws and
                    regulations in their state of licensure. These laws vary by
                    state and may include requirements regarding:
                </p>
                <ul>
                    <li>
                        Establishing a provider-patient relationship via
                        telemedicine
                    </li>
                    <li>
                        Informed consent requirements specific to telehealth
                    </li>
                    <li>Prescribing limitations and restrictions</li>
                    <li>Documentation requirements</li>
                    <li>Technology and security standards</li>
                    <li>Insurance coverage and reimbursement</li>
                    <li>Licensing requirements for cross-state practice</li>
                </ul>
                <p>
                    Patients should be aware that state laws may limit the types
                    of services that can be provided through telemedicine.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    17.1.2 Federal Healthcare Laws
                </h4>
                <p>
                    The Platform and services provided through it are subject to
                    various U.S. federal healthcare laws and regulations,
                    including but not limited to:
                </p>
                <ul>
                    <li>
                        Health Insurance Portability and Accountability Act
                        (HIPAA)
                    </li>
                    <li>
                        Health Information Technology for Economic and Clinical
                        Health Act (HITECH)
                    </li>
                    <li>Federal Food, Drug, and Cosmetic Act (FDCA)</li>
                    <li>Controlled Substances Act (CSA)</li>
                    <li>Federal Anti-Kickback Statute</li>
                    <li>Stark Law (Physician Self-Referral Law)</li>
                    <li>Medicare and Medicaid regulations</li>
                </ul>
                <p>
                    Healthcare Providers must comply with all applicable federal
                    laws and regulations when providing services through the
                    Platform.
                </p>

                <h4 className="h6 fw-bold mb-2">17.2 India</h4>

                <h4 className="h6 fw-bold mb-2">
                    17.2.1 Telemedicine Guidelines
                </h4>
                <p>
                    The Platform complies with applicable telemedicine
                    guidelines in India, including:
                </p>
                <ul>
                    <li>
                        Telemedicine Practice Guidelines issued by the Board of
                        Governors in supersession of the Medical Council of
                        India
                    </li>
                    <li>
                        Information Technology Act, 2000, and its amendments
                    </li>
                    <li>
                        Digital Information Security in Healthcare Act (when
                        effective)
                    </li>
                    <li>
                        Other applicable healthcare regulations issued by the
                        Ministry of Health and Family Welfare
                    </li>
                </ul>
                <p>
                    Patients in India should understand that these guidelines
                    may limit the scope of services that can be provided through
                    telemedicine, particularly regarding prescriptions and
                    certain types of consultations.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    17.2.2 Medical Practice Regulations
                </h4>
                <p>
                    While Healthcare Providers on the Platform are licensed in
                    the United States, not India, the services provided to
                    patients in India must still comply with applicable Indian
                    laws governing medical practice, including:
                </p>
                <ul>
                    <li>Indian Medical Council Act and regulations</li>
                    <li>Drugs and Cosmetics Act and Rules</li>
                    <li>
                        Clinical Establishments (Registration and Regulation)
                        Act
                    </li>
                    <li>
                        Any state-specific healthcare regulations applicable to
                        the patient’s location
                    </li>
                </ul>
                <p>
                    Healthcare Providers must be aware of these regulations and
                    their implications for providing services to patients in
                    India.
                </p>

                <h4 className="h6 fw-bold mb-2">
                    17.3 Cross-Border Practice Limitations
                </h4>
                <p>
                    Due to the cross-border nature of the Platform, certain
                    limitations apply:
                </p>
                <ul>
                    <li>
                        Prescribing controlled substances is prohibited through
                        the Platform
                    </li>
                    <li>
                        Certain medication classes may be restricted based on
                        either U.S. or Indian regulations
                    </li>
                    <li>
                        Emergency services cannot be provided through the
                        Platform
                    </li>
                    <li>
                        Certain invasive procedures or treatments cannot be
                        recommended or provided
                    </li>
                    <li>
                        Laboratory or diagnostic testing orders may be subject
                        to local availability and regulations
                    </li>
                    <li>
                        Follow-up care may be limited by jurisdictional
                        boundaries
                    </li>
                    <li>
                        Certain types of medical documentation may not be
                        recognized across borders
                    </li>
                    <li>
                        Insurance coverage and reimbursement may be limited or
                        unavailable
                    </li>
                </ul>
                <p>
                    Users acknowledge these limitations and agree to work within
                    the established regulatory frameworks of both countries when
                    using the Platform.
                </p>
            </ul>
        </div>
    );
};

export default TermsAndConditionsq;
